<template>
  <div>
    <div @click="launchFilePicker()">
      <slot name="activator"></slot>
    </div>
    <input
      type="file"
      style="display: none"
      ref="file"
      @change="onFileChange"
    >
    <v-dialog v-model="errorDialog" max-width="300">
      <v-card>
        <v-card-text class="subheading">{{errorText}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="errorDialog = false" flat>Got it!</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'fileUploader',
  data: () => ({
    errorDialog: null,
    errorText: ''
  }),
  props: {
    value: Object
  },
  methods: {
    launchFilePicker () {
      this.$refs.file.click()
    },
    onFileChange (e) {
      const files = e.target.files
      // check if user actually selected a file
      if (files.length > 0) {
        const file = files[0]
        const fieldName = file.name
        let fileURL = URL.createObjectURL(file)
        this.$emit('input', { fileName: fieldName, file, fileURL })
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/uploader/fileUploader.vue